module.exports = __webpack_public_path__ + "static/logo-42b2b3165965ead21eeb82f1016e9355.svg";